import { ISpinnerProps, Spinner as BaseSpinner, SpinnerSize as FluentSpinnerSize } from "@fluentui/react";

export type SpinnerProps = ISpinnerProps;

export const SpinnerSize = FluentSpinnerSize;

export const Spinner = BaseSpinner;
